import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import { IStoreState } from "../../../../../../reducers/types";
import {
  getHasSetStopsOption,
  getHasSetReturnTimeRange,
  getHasSetOutboundTimeRange,
  getHasSetAirportFilter,
  getHasSetAirlineFilter,
  getHasSetFlightNumberFilter,
  getHasSetPolicyFilter,
} from "../../../../reducer/selectors";
import { initialFilterOptions } from "../../../../reducer";
import {
  hasSetMaxPriceFilterSelectorV2,
  maxFlightPriceSelectorV2,
} from "../../../../../shop/reducer/selectors";
import { actions } from "../../../../actions";
import {
  IRerunPrediction,
  setRerunPrediction,
} from "../../../../../shop/actions/actions";
import { AppliedFilterTags } from "./component";

interface IStateProps {
  filters: { [key: string]: boolean };
  data: { maxFlightPrice: number };
}

const mapStateToProps = (state: IStoreState): IStateProps => {
  return {
    filters: {
      stops: getHasSetStopsOption(state),
      airline: getHasSetAirlineFilter(state),
      price: hasSetMaxPriceFilterSelectorV2(state),
      departure: getHasSetOutboundTimeRange(state),
      return: getHasSetReturnTimeRange(state),
      airport: getHasSetAirportFilter(state),
      flightNumber: getHasSetFlightNumberFilter(state),
      policy: getHasSetPolicyFilter(state),
    },
    data: {
      maxFlightPrice: maxFlightPriceSelectorV2(state),
    },
  };
};

type ResetFunctions =
  | {
      [key: string]: () => void;
    }
  | {
      price: () => void;
    };

interface IDispatchProps {
  setRerunPrediction: () => IRerunPrediction;
  reset: ResetFunctions;
  resetAll: () => void;
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => {
  return {
    setRerunPrediction: () => dispatch(setRerunPrediction()),
    reset: {
      stops: () =>
        dispatch(actions.setStopsOption(initialFilterOptions.stopsOption)),
      airline: () =>
        dispatch(actions.setAirlineFilter(initialFilterOptions.airlineFilter)),
      price: () =>
        dispatch(
          actions.setMaxPriceFilter(initialFilterOptions.maxPriceFilter)
        ),
      airport: () =>
        dispatch(actions.setAirportFilter(initialFilterOptions.airportFilter)),
      policy: () =>
        dispatch(actions.setPolicyFilter(initialFilterOptions.policyFilter)),
      flightNumber: () =>
        dispatch(
          actions.setFlightNumberFilter(initialFilterOptions.flightNumberFilter)
        ),
      departure: () => {
        dispatch(
          actions.setOutboundArrivalTimeRange(
            initialFilterOptions.outboundArrivalTimeRange
          )
        );
        dispatch(
          actions.setOutboundDepartureTimeRange(
            initialFilterOptions.outboundDepartureTimeRange
          )
        );
      },
      return: () => {
        dispatch(
          actions.setReturnDepartureTimeRange(
            initialFilterOptions.returnDepartureTimeRange
          )
        );
        dispatch(
          actions.setReturnArrivalTimeRange(
            initialFilterOptions.returnArrivalTimeRange
          )
        );
      },
    },
    resetAll: () => {
      dispatch(actions.setStopsOption(initialFilterOptions.stopsOption));
      dispatch(actions.setAirlineFilter(initialFilterOptions.airlineFilter));
      dispatch(
        actions.setFareclassOptionFilter({
          basic: false,
          standard: false,
          enhanced: false,
          premium: false,
          luxury: false,
        })
      );
      dispatch(actions.setMaxPriceFilter(initialFilterOptions.maxPriceFilter));
      dispatch(actions.setAirportFilter(initialFilterOptions.airportFilter));
      dispatch(actions.setPolicyFilter(initialFilterOptions.policyFilter));
      dispatch(
        actions.setFlightNumberFilter(initialFilterOptions.flightNumberFilter)
      );
      dispatch(
        actions.setOutboundArrivalTimeRange(
          initialFilterOptions.outboundArrivalTimeRange
        )
      );
      dispatch(
        actions.setOutboundDepartureTimeRange(
          initialFilterOptions.outboundDepartureTimeRange
        )
      );
      dispatch(
        actions.setReturnDepartureTimeRange(
          initialFilterOptions.returnDepartureTimeRange
        )
      );
      dispatch(
        actions.setReturnArrivalTimeRange(
          initialFilterOptions.returnArrivalTimeRange
        )
      );
    },
  };
};

const mergeProps = (stateProps: IStateProps, dispatchProps: IDispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    resets: {
      reset: {
        ...dispatchProps.reset,
        price: () => dispatchProps.reset.price(),
      },
      resetAll: () => dispatchProps.resetAll(),
    },
  };
};

export type AppliedFilterTagsProps = ConnectedProps<typeof connector>;

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export const ConnectedAppliedFilterTags = connector(AppliedFilterTags);
